// extracted by mini-css-extract-plugin
export default {"overlay":"Overlay_overlay__xBtaI","transparent":"Overlay_transparent__be5Ml","opaque":"Overlay_opaque__-PVLp","empty":"Overlay_empty__Kjb0i","loading":"Overlay_loading__TclG7"};